import {
  HAS_SUBMITTED_CONTACT_FORM,
  SHOW_CONTACT_SALES_FORM_MODAL,
  SHOW_CONTACT_SUPPORT_FORM_MODAL,
} from 'actions/contact';

const INITIAL_STATE = {
  showSupportFormModal: false,
  showSalesFormModal: false,
  selectedPlan: 'unspecified',
  hasSubmitted: false,
  initialMessage: '',
  ticketSubject: '',
};

const contactReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SHOW_CONTACT_SUPPORT_FORM_MODAL:
      return {
        ...state,
        showSupportFormModal: action.showSupportFormModal,
        initialMessage: action.initialMessage || '',
        ticketSubject: action.ticketSubject || '',
        hasSubmitted: false,
      };

    case SHOW_CONTACT_SALES_FORM_MODAL:
      return {
        ...state,
        showSalesFormModal: action.showSalesFormModal,
        selectedPlan: action.selectedPlan,
        hasSubmitted: false,
      };

    case HAS_SUBMITTED_CONTACT_FORM:
      return {
        ...state,
        hasSubmitted: true,
      };
    default:
      return state;
  }
};

export default contactReducer;
